import { render, staticRenderFns } from "./eg_avatar.vue?vue&type=template&id=2e2f8ca6&"
import script from "./eg_avatar.vue?vue&type=script&lang=js&"
export * from "./eg_avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports